# EXPERIMENT: teamMembersTabLayoutV1
# This component is currently only being used for
# the new variation in adding members to a team
t = require('views/internal/teacup-with-helpers')('manage_members')

module.exports = t.renderable ({ canInviteMembers, canLinkGoogleApps, placeholder, disableAddingExternalMembers, isBCOrgAdmin, orgSettingsURL, canAddMembers, orgName, isPerUser, isMonthly, isYearly, perUserPrice, orgMemsView }) ->
  orgName ?= ""

  t.div '.org-actions-popover', ->
    if canInviteMembers
      t.div '.manage-member-invitation-section', ->
        t.div '.search-with-spinner', { style: 'height: auto' }, ->
          t.h4 ->
            t.icon 'member', 'enter-email-address-or-name'
          t.input '.js-search-input.js-autofocus', { type: 'text', style: 'margin-bottom: 0;', placeholder }
          t.div '.spinner.small.hide.js-loading'
          t.p '.u-bottom.quiet.bulk-add-members-copy', ->
            t.format 'big-team'
            t.a '.js-bulk-add-members.u-bottom.action-link', { href: '#' }, ->
              t.format 'add-many-people-at-once'

    if disableAddingExternalMembers
      t.div '.search-with-spinner', ->
        t.input '.js-search-input.js-autofocus', { type: 'text', style: 'margin-bottom: 0;', placeholder }
        t.div '.spinner.small.hide.js-loading'
      t.p '.warning', ->
        if isBCOrgAdmin
          t.format 'only-organization-members-can-be-added-to-this-board-to-change-this-visit-the-organization-settings-page-and-click-inviting-non-org-members-to-boards', { orgSettingsURL }
        else
          t.format 'only-organization-members-can-be-added-to-this-board-check-with-an-organization-admin-to-change-this-setting'

    t.div '.pop-over-section.hide.js-board-members', ->
      t.ul '.pop-over-member-list.options.js-list'

    t.div '.pop-over-section.hide', ->
      t.h4 ->
        t.format 'error'
      t.p '.error', ->
        t.format 'the-user-or-email-could-not-be-invited-due-to-an-organization-restriction'

    t.div '.pop-over-section.hide.js-error', ->
      t.p '.error', { style: 'margin: 16px 8px 6px;' }

    if canAddMembers
      t.div '.pop-over-section.hide.js-uninvited-search-results'

      t.div '.pop-over-section.hide.js-search-results', ->
        t.h4 ->
          t.format 'select-to-add'
        t.ul '.pop-over-member-list.options.js-list'

      t.div '.pop-over-section.hide.js-no-results', ->
        t.p '.quiet.u-text-align-center', { style: 'padding: 16px 4px;' }, ->
          t.format 'no-results'

      t.div '.pop-over-section.hide.js-org-members', ->
        t.h4 ->
          t.format 'orgname-members', { orgName }
        t.ul '.pop-over-member-list.options.u-clearfix.js-list',
          class: t.classify
            collapsed: orgMemsView
          style: t.stylify
            'margin-bottom': if orgMemsView then '8px' else undefined
        t.a '.quiet-button.js-add-all-org-members', { href: '#', style: 'margin-top: 8px;' }
        t.a '.quiet-button.js-more-org-members.hide', { href: '#', style: 'margin-top: 8px;' }, ->
          t.format 'view-all-members'

    if isPerUser
      t.p '.quiet.u-bottom', { style: 'padding: 6px;' }, ->
        if isMonthly
          t.format 'business-class-pricing-is-per-user-adding-a-member-will-increase-the-price-by-jpsprice-per-month', { jpsPrice: perUserPrice }
        if isYearly
          t.format 'business-class-pricing-is-per-user-adding-a-member-will-increase-the-price-by-jpsprice-per-year', { jpsPrice: perUserPrice }

    if canInviteMembers
      t.div '.manage-member-invitation-section', ->
        t.div '.manage-member-invitation-link-header', ->
          t.h4 ->
            t.img '.icon-share-link', { src: require('images/icon-link.svg') }
            t.format 'share-team-invite-link'
          t.a '.action-link.js-show-invitation-link', { href: '#' }, ->
            t.format 'create-link'

        t.div '.manage-member-invitation-link.hide.js-invitation-link-container', ->
          t.div '.manage-member-invitation-link-actions', ->
            t.input '.js-invitation-link',
              type: 'text'
              readonly: 'readonly'
              placeholder: t.l 'loading'

            t.button '.button.primary.js-copy-link', ->
              t.format 'copy'
          t.a '.quiet.js-deactivate-link', { href: '#' }, ->
            t.format 'disable-this-link'

    if canInviteMembers
      t.div '.js-ad'

    if canLinkGoogleApps
      t.div '.js-link-google-apps', ->
        t.div '.pop-over-ad.business-class-ad', ->
          t.img '.icon-google-g.pop-over-ad-icon', { src: require('images/services/google-g-logo.svg') }
          t.div '.ad-copy', ->
            t.span '.title', -> t.format 'using-google-apps'
            t.span '.learn-more', -> t.format 'link-google-apps-domain'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/invite_members.coffee